// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vvTK","title":"Header_title__3N6T8","left":"Header_left__FVnDo","clinicName":"Header_clinicName__3gDI5"};